import { types } from "../types/types";
import { fetchConToken } from "../helpers/fetch";
///import { spinner, spinnerClose } from '../helpers/spinners';
import { startSpinner, finishSpinner } from "./ui/spinner";
import { startAlerta } from "./ui/alertas";
export const grupoFamiliarTraerStart = () => ({ type: types.grupoFamiliarTraerStart });
export const grupoFamiliarLimpiar = () => ({ type: types.grupoFamiliarLimpiar });
export const grupofamiliarTraerError = (error) => ({ type: types.grupoFamiliarTraerError, payload: error });
export const grupoFamiliarTraerSuccess = (payload) => {
  return {
    type: types.grupoFamiliarTraerSuccess,
    payload: payload
  }
}

export const fetchGrupoFamiliar = (idAfiliado) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      dispatch(grupoFamiliarTraerStart());
      const response = await fetchConToken(`GrupoFamiliares/traerGrupoFamiliarPorIdAfiliado/${idAfiliado}`);
      if (response.status !== 200) throw response.errores;
      const contentType = response.headers.get("content-type");
      if (contentType && contentType.indexOf("application/json") !== -1) {
        const lista = await response.json();        
        if (lista.length > 0) {
          dispatch(grupoFamiliarTraerSuccess(lista));
        }
      }
      dispatch(finishSpinner());
    } catch (err) {
      dispatch(finishSpinner());
      dispatch(grupofamiliarTraerError(err));
      dispatch(startAlerta(err?.mensaje, "warning", `¡Error!`));
      console.log('error de EP', err);
    }
  };
};

export const fetchGrupoFamiliarAfiliadoPreinscriptoStage = (idGrupoFamiliar) => {
  return async (dispatch) => {
    dispatch(startSpinner());
    dispatch({ type: types.grupoFamiliarPreinscriptoTraerStart });
    const response = await fetchConToken(`PreAfiliados/FamiliartraerPorIdGrupoFamiliar/${idGrupoFamiliar}`);
    if (!response.ok) {
      dispatch(grupofamiliarTraerError(response.statusText));
      throw Error(response.statusText);
    }
    const contentType = response.headers.get("content-type");
    if (contentType && contentType.indexOf("application/json") !== -1) {
      const lista = await response.json();
      if (lista.length > 0) {
        dispatch({
          type: types.grupoFamiliarPreinscriptoTraerSuccess,
          payload: lista
        });
      }
    }
    dispatch(finishSpinner());
  };
};
